<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="充值金额" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
                    v-model="info.money"
              placeholder="请输入充值金额"
              v-decorator="[
          'money',
          {rules: [{ required: true, message: '请输入充值金额!' }],initialValue:info.money}
        ]"
            ></a-input>
          </a-form-item>
          <pxkeji-btn
                  name="选择用户"
                  class="pxkeji_basic_btn"
                  @click="selectStudent()"
                  type="primary"
          />
          <a-table
                  :columns="list.columns"
                  rowKey="id"
                  :pagination="list.pagination"
                  :dataSource="list.datas"
                  :loading="isloading"
                  :locale="{emptyText:'暂无数据'}"
          >
          </a-table>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
      <a-modal
              title="选择用户"
              v-model="userList.visible"
              :footer="false"
              destroyOnClose
              :maskClosable="false"
              width="80%"
      >
        <selectUser :id="studentList" @callbackMethod="selectUserBack"/>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
  import selectUser from "./chargeSelectUser.vue";
var that;
  const columns = [
    {
      dataIndex: "fullName",
      key: "fullName",
      align: "center",
      title: "学员名称",
    },
    {
      dataIndex: "telephone",
      key: "telephone",
      align: "center",
      title: "手机号",
    },
    {
      dataIndex: "idCard",
      key: "idCard",
      align: "center",
      title: "身份证号",
    },
    {
      dataIndex: "sex",
      key: "sex",
      align: "center",
      title: "性别",
    },
    {
      key: "action",
      align: "center",
      title: "地区",
      scopedSlots: {customRender: "action"},
    },
    {
      dataIndex: "enterprise.name",
      key: "enterpriseName",
      align: "center",
      title: "所属单位",
    },
    {
      dataIndex: "extensions.groupName",
      key: "groupName",
      align: "center",
      title: "管理组名称",
    },
  ];

export default {
  props: {
    infos: {
      type: Object,
    },
    id: String
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      form: this.$form.createForm(this),
      info: {
        money:"",
      },
      servicelists: [],
      studentList:[],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      userList: {
        visible: false,
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          company: "",
          studentIds: "",
          provience: "",
          city: "",
          area: "",
          groupIds: "",
        }
      },
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      service: {
        //服务项目
        visible: false
      },
      good: {
        //擅长项目
        visible: false
      },
      schedule: {
        //排班
        visible: false,
        list: ""
      }
    };
  },
  components: {
    selectUser
  },
  mounted() {
    this.$nextTick(function() {
      that = this;

      if (!this.type) {
        this.dis = true;
      }
    });
  },
  methods: {
    selectStudent() {
      this.userList.visible = true;
    },
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    getservice(data) {
      this.service.visible = false;
      this.servicelists = [];
      this.serviceNames = [];
      this.serviceIds = [];
      data.forEach(function(item, index) {
        that.servicelists.push({
          name: item.name,
          id: item.id,
          img: item.img
        });
        that.serviceNames.push(item.name);
        that.serviceIds.push(item.id);
      });
      that.info.serviceNames = this.serviceNames.join(",");
      this.form.setFieldsValue({
        serviceNames: this.serviceNames.join(",")
      });
    },



    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.studentList.length == 0) {
            this.$message.error("请选择用户");
            return;
          }
          //新增
          this.isloading = true;
          this.loadingTip = "保存中...";
          this.$api.recharge
                  .rechargeBatch(
                          this.studentList.join(","),
                          this.info.money,
                      "线下充值"
                  )
                  .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                      this.$message.success(res.errorMsg);
                      this.$emit("callbackMethod");
                    } else {
                      this.$message.error(res.errorMsg);
                    }
                  })
                  .catch(() => {
                    this.isloading = false;
                  });

        }
      });
    },


    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      var params = {
        pageNow: this.list.pagination.current,
        pageSize: this.list.pagination.defaultPageSize,
        name: this.where.keyword.name,
        enterpriseName: this.where.keyword.company,
        studentIds: this.where.keyword.studentIds,
      };
      if (this.where.keyword.groupIds) {
        params.groupId = this.where.keyword.groupIds;
      }
      if (this.where.keyword.area) {
        params.province = this.where.keyword.province;
        params.city = this.where.keyword.city;
        params.area = this.where.keyword.area;
      }
      this.$api.student
              .getPagedList(params)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.list.datas = res.data.records;
                  for (let i = 0; i < this.list.datas.length; i++) {
                    var ex = this.list.datas[i].extensions;
                    this.list.datas[i].extensions = JSON.parse(ex);
                  }
                  this.list.pagination.total = Number(res.data.total);
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
    },

    selectUserBack(name, company, studnetIds, provience, city, area, groupIds) {
      //获取列表
      this.isloading = true;
      this.$api.order
              .getStudentList(name, company, studnetIds, provience, city, area, groupIds)
              .then((res) => {
                console.log(res);
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.where.keyword.name = name == null ? "" : name;
                  this.where.keyword.enterpriseName = company;
                  this.where.keyword.studentIds = studnetIds;
                  this.where.keyword.provience = provience;
                  this.where.keyword.city = city;
                  this.where.keyword.area = area;
                  this.where.keyword.groupIds = groupIds;
                  this.userList.visible = false;
                  this.studentList = res.data;
                  console.log(this.studentList);
                    this.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
</style>